module.exports = __webpack_public_path__ + "static/media/leadership-image5.77384cf0.jpg";